import * as React from "react";
import { AddCircle20Regular, Settings20Regular } from "@fluentui/react-icons";
import { useAiSearchOption } from "../utils/aiSearchOption";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { setUsageType, searchDataChanged, setEditableFields, updateEditableFields, updateUsageGroupMatches } from "../../redux/reducers/RepertoireReducer";
import { ITabReduxItem } from "../../redux/types/ITabReduxItem";
import IRepertoireComponentDataItem from "../../redux/types/IRepertoireComponentDataItem";
import SelectorView from "../../repertoire/components/selectorView/SelectorView";
import UsageSearchView from "../components/usageComponents/searchView/UsageSearchView";
import AiSearchView from "../components/searchView/AiSearchView";
import {
    FINDUSAGE_PAGE_VIEW,
    SEARCH_VIEW_USAGES,
    USAGESEARCH_VIEW,
    USAGETOWORK,
    USAGETOPRODUCT,
    SEARCH_VIEW,
    TITLE_EDITABLE_FIELDS_VIEW,
    USAGE_SEARCH_EDITABLE_FIELDS,
    EDITABLE_FIELDS,
    REPERTOIRE,
    WORK_MAINTENANCE_TOOLBAR,
    USAGERESULTTABLE_VIEW,
    ALL_ROLES,
    VIEW_DISTRIBUTIONS_ROLE,
    VIEW_POOLS_ROLE,
    CONFIGURE_USAGES_ROLE,
    VIEW_USAGES_ROLE,
    UPDATE_USAGES_ROLE,
    ADVANCED,
    SIMPLE,
    DATA_GRID_TABLE_FIELDS_EXPANDER,
    SEARCH_VIEW_USAGES_USAGE_TO_PRODUCT,
    SEARCH_VIEW_USAGES_USAGE_TO_WORK,
    VIEW_COMPONENT_ROLE,
    CONFIGURE_USAGES_DETAILS_ROLE,
    CREATE_NEW_USAGE_ROLE,
    USAGE_SEARCH_SOURCE_COSMOS,
    USAGE_SEARCH_SOURCE_LAKEHOUSE,
    USAGE_SEARCH_SOURCE_PRIMARY_LABEL,
    USAGE_TO_WORK,
    USAGE_TO_PRODUCT
} from "../Consts";
import { IMatchWorksSearchQuery } from "../types/usageTypes/IMatchWorksSearchQuery";
import { IMatchWorksSearchResult } from "../types/usageTypes/IMatchWorksSearchResult";
import { IUsageGroupResult, IUsageGroupsSearchResult, IUsageSearchResultRowType } from "../types/usageTypes/IUsageGroupsSearchResult";
import { IRepertoireField } from "../types/IRepertoireField";
import { IUsagesSearchQuery } from "../types/usageTypes/IUsagesSearchQuery";
import { ISourceMatchType } from '../../settings/types/ISourceMatchType';
import { Dictionary } from '../../core/types/Dictionary';
import { hideModal, showModal, showUpdateFieldsModal } from "../../redux/reducers/ModalReducer";
import { IShowFieldSettingViewModalProps } from "../components/repertoireModal/RepertoireModal";
import { getDataAction } from "../components/toolBar/ToolbarHelper";
import { IDataActionToolbar } from "../types/IDataActionToolbar";
import { FormatFields } from "../../redux/types/FormatFields";
import { UsageSearchRequests } from "../services/usageServices/UsageSearchRequests";
import { CONFIGURATION_PARAMETER_DEFAULT_USAGE_SEARCH_SOURCE, CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, PRODUCT_MAINTENANCE_GROUP, USAGE_MAINTENANCE_GROUP, WORK_MAINTENANCE_GROUP } from "../ConfigurationConsts";
import { IMatchProductsSearchQuery } from "../types/usageTypes/IMatchProductsSearchQuery";
import { IProductSearchResult } from "../types/IProductSearchResult";
import { ITreeData } from "../types/ITreeData";
import { IDistributionType } from "../types/usageTypes/IDistibutionType";
import { IDistribution } from "../types/usageTypes/IDistribution";
import { IActiveAccordion } from "../../redux/types/IActiveAccordion";
import { IResultsPerPage } from "../../redux/types/IResultsPerPage";
import { useMsal } from "@azure/msal-react";
import { ComponentsHelper } from "../../core/services/ComponentHelper";
import { msalConfig } from "../../accounts/types/msalAuthConfig";
import IEditableFieldsComponentData from "../types/IEditableFieldsComponentData";
import { IUsagePoolSearchQuery } from "../types/usageTypes/IUsagePoolSearchQuery";
import { IDistributionSearchQuery } from "../../repertoire/types/usageTypes/IDistributionSearchQuery";
import { IUsageSearcResultConfiguration } from "../../repertoire/types/usageTypes/IUsageSearcResultConfiguration";
import { IComponentView } from "../../redux/types/ComponentView";
import { IComponentViewsPreference } from "../../redux/types/IComponentViewsPreference";
import { IApplyMatchToMultipleRecordsRequest } from "../types/usageTypes/IApplyMatchToMultipleRecordsRequest";
import { IApplyMatchToMultipleRecordsResponse } from "../types/usageTypes/IApplyMatchToMultipleRecordsResponse";

export interface IFindUsagePageProps {
    findUsagePageData: IRepertoireComponentDataItem;
    searchViewData: IRepertoireComponentDataItem;
    bulkTargetSearchViewData: IRepertoireComponentDataItem;
    settingsModalViewData: IRepertoireComponentDataItem;
    searchResultsTableData: IRepertoireComponentDataItem;
    searchUsages: (query: IUsagesSearchQuery, modalOpen: boolean, usageType: string, lookupSources: ITreeData[], continuationToken?: string) => void;
    submitBulkMatch: (request: IApplyMatchToMultipleRecordsRequest) => Promise<IApplyMatchToMultipleRecordsResponse>;
    usageGroupsSearchResult: IUsageGroupResult[];
    matchWorkSearchResult: IMatchWorksSearchResult[];
    searchSuccessful: boolean;
    activeTab?: number;
    tabs?: ITabReduxItem[];
    updateComponentFieldsItems: (fields: IRepertoireField[],
        componentName: string,
        componentInstance: string,
        componentDataFieldName: string,
        tabs: ITabReduxItem[],
        activeTab: number) => void;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    isHundredResultsPerPage?: boolean;
    currentPage?: number;
    getUsageDetails: (usageID: string, lookupValues?: ILookupDictionary, openEntityForWorkflowSession?: boolean) => void;
    getDistributionDetails?: (distributionID: number, lookupValues: ILookupDictionary) => void;
    getUsagePool?: (poolId: number,matchingSources: ITreeData[]) => void;
    resetPagination: (repertoireSection: string) => void;
    setIsHundredResultsPerPage?: (isHundredResultsPerPage: boolean) => void;
    lookupValues: ILookupDictionary;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    distributions: { id: number; code: string; description: string; }[];
    pools: { id: number; code: string; description: string; }[];
    sourceMajors: { code: string; description: string; }[];
    sourceMinors: { code: string; description: string; }[];
    getDistributions?: () => void;
    getPools?: () => void;
    searchMatchWorks: (query: IMatchWorksSearchQuery, modalOpen: boolean, lookupValues?: ILookupDictionary) => void;
    expandedMatchWorkResults?: number[];
    usageExpandAll?: boolean,
    usageExpandAllResults?: () => void;
    expandMatchWorkResult: (matchWorkResults: number) => void;
    setUsageType: typeof setUsageType;
    usageType: string;
    searchDataChanged: typeof searchDataChanged;
    getSources: () => void;
    enableUsageSearchSourceSelector?: boolean;
    getEnableUsageSearchSourceSelector?: () => void;
    sources: Dictionary<ISourceMatchType>;
    updateEditableField: typeof updateEditableFields;
    searchEditableFields?: IRepertoireField[];
    showUpdateFieldsModal?: typeof showUpdateFieldsModal;
    editableFieldsDataView: IRepertoireComponentDataItem;
    hideModal?: typeof hideModal;
    dataGridTableData?: IRepertoireComponentDataItem;
    editableFields: IEditableFieldsComponentData;
    setEditableFields: typeof setEditableFields;
    searchMatchProducts: (query: IMatchProductsSearchQuery, modalOpen: boolean) => void;
    matchProductsSearchResult?: IProductSearchResult[];
    getWorkDetails: (dataSource: string, workID: number, lookups: ILookupDictionary, otherIndicatorsWorkFlagTypes: string[], readonlyIndicatorsWorkFlagTypes: string[], dataActions?: IDataActionToolbar[], workMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem, formats?: FormatFields[]) => void;
    workMaintenanceGeneralDataViewData?: IRepertoireComponentDataItem;
    getProductDetails: (dataSource: string, productID: number, productMaintenanceGeneralDataView: IRepertoireComponentDataItem, formats: FormatFields[]) => void;
    productMaintenanceGeneralDataViewData: IRepertoireComponentDataItem;
    lookupSources?: ITreeData[];
    sortSearchResults: (name: string, results: any) => void;
    getDistributionTypes: () => void;
    distributionTypes: IDistributionType[];
    defaultActiveAccordions?: IActiveAccordion[];
    allResultsPerPage?: IResultsPerPage[];
    updateUserPreferences: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string, componentViewsPreference?: IComponentViewsPreference) => void;
    continuationToken?: string;
    roles?: string[];
    saveRoles?: (roles: string[]) => void;
    updateUsageGroupMatches?: typeof updateUsageGroupMatches;
    saveUsageGroup?: (updatedUsageGroup: IUsageSearchResultRowType) => void;
    saveResultData?: IRepertoireComponentDataItem;
    expanderFieldsData?: IRepertoireField[];
    showModal?: typeof showModal;
    matchingEntityForUsageSearchCriteria?: { id: number, number: string; }
    usageMatchingDefaultsProducts?: string[];
    usageMatchingDefaultsWorks?: string[];
    matchingSources: ITreeData[];
    searchUsagePoolsByCodeDistributionPools?: (query: IUsagePoolSearchQuery) => void;
    poolCodeToSearch?: string;
    updatePoolCodeToSearch?: (value: string) => void;
    customer?: string
    usagePoolsSearchResults
    getProductMaintenanceEnableCuesheets?:()=>void;
    getProductMaintenanceCuesheetsDataSource?: () => void;
    searchDistributionByCode: (query: IDistributionSearchQuery) => void;
    distributionCodeToSearch: string;
    updateDistributionCodeToSearch: (value: string) => void;
    usageDistributionsSearchResults;
    usageSearchResultConfiguration?: IUsageSearcResultConfiguration;
    updateComponentViews: (componentViews: any[]) => void;
    getComponentViews: (componentName: string, componentInstance: string) => void;
    createNewUsageGroup: (lookups: ILookupDictionary, isNew?: boolean, distributionCode?: string, currentUser?: string) => void;
    componentViews?: any;
    usageSearchResultsActiveComponentView?: IComponentView;
    setActiveComponentView?: (activeComponentView: IComponentView) => void;
    componentViewPreference?: IComponentViewsPreference;
    searchArtistValue?: string;
    searchCustomerVenueCodeValue?: string;
    searchLicenseCustomerVenueCodeValue?: string;
    searchCustomerVenueValue?: string;
    searchLicenseCustomerVenueValue?: string;
    usageNumberInSearchExclude?: string[];
}

const normalizeUsageSearchSource = (value: unknown): string => {
    const normalized = String(value ?? "").trim().toLowerCase();

    return normalized === USAGE_SEARCH_SOURCE_LAKEHOUSE.toLowerCase()
        ? USAGE_SEARCH_SOURCE_LAKEHOUSE
        : USAGE_SEARCH_SOURCE_COSMOS;
};

const FindUsagePage = (props: IFindUsagePageProps) => {
    const [loaded, setLoaded] = React.useState(false)
    const [searchType, setSearchType] = React.useState(SIMPLE);
    const [searchSource, setSearchSource] = React.useState(USAGE_SEARCH_SOURCE_COSMOS);
    const { option3, option3Label } = useAiSearchOption(props.searchViewData, searchType, setSearchType);
    const { instance, accounts } = useMsal()
    const [hasLoadedDistributions, setHasLoadedDistributions] = React.useState(false);
    const [hasLoadedPools, setHasLoadedPools] = React.useState(false);
    const [userIsConfigureComponentViewAdmin, setUserIsConfigureComponentViewAdmin] = React.useState(false);
    const currentUser = accounts[0]?.username;
    React.useEffect(() => {
        getRoles();
        checkIfLoaded();

        const account = accounts[0]
        ComponentsHelper.createBearerHeaderFromAADLogin(instance, account);
        const {
            sources,
            getSources,
            getDistributionTypes,
            getProductMaintenanceEnableCuesheets,
            getProductMaintenanceCuesheetsDataSource,
            getComponentViews,
            enableUsageSearchSourceSelector,
            getEnableUsageSearchSourceSelector
        } = props;
        getProductMaintenanceEnableCuesheets && getProductMaintenanceEnableCuesheets();
        getProductMaintenanceCuesheetsDataSource && getProductMaintenanceCuesheetsDataSource();
        if (!sources)
            getSources();

        getEnableUsageSearchSourceSelector && getEnableUsageSearchSourceSelector();

        UsageSearchRequests
            .getConfigurationParameter(
                CONFIGURATION_PARAMETER_DEFAULT_USAGE_SEARCH_SOURCE,
                USAGE_MAINTENANCE_GROUP)
            .then(defaultSearchSource => {
                setSearchSource(normalizeUsageSearchSource(defaultSearchSource));
            })
            .catch(() => {
                setSearchSource(USAGE_SEARCH_SOURCE_COSMOS);
            });

        getComponentViews(SEARCH_VIEW, SEARCH_VIEW_USAGES)

       getDistributionTypes();
    }, [])

    React.useEffect(() => {        
        const {
            distributions,
            pools,
            getDistributions,
            getPools,
            roles
        } = props;

        checkIfLoaded();

        if (!hasLoadedDistributions && roles.length > 0 && distributions.length === 0 && (roles.includes(VIEW_DISTRIBUTIONS_ROLE) || roles.includes(ALL_ROLES))) {
            getDistributions();
            setHasLoadedDistributions(true);
        }
        if (!hasLoadedPools && roles.length > 0 && pools.length === 0 && (roles.includes(VIEW_POOLS_ROLE) || roles.includes(ALL_ROLES))) {
            getPools();
            setHasLoadedPools(true);
        }

        if(roles.includes(VIEW_COMPONENT_ROLE) || roles.includes(ALL_ROLES) || roles.includes(CONFIGURE_USAGES_DETAILS_ROLE)) {
            setUserIsConfigureComponentViewAdmin(true);
        }
    }, [props.distributions, props.pools, props.roles, props.findUsagePageData, props.searchViewData, props.editableFields])

    const canUpdateUsages = Boolean(
        props.roles?.includes(
            UPDATE_USAGES_ROLE
        ) ||
        props.roles?.includes(
            ALL_ROLES
        )
    );

    const onSetActiveComponentView = (activeComponentView: IComponentView) => { 
        const { setActiveComponentView, updateUserPreferences, allResultsPerPage, defaultActiveAccordions,indexOfFirstResult, indexOfLastResult, resultsPerPage, componentViewPreference } = props;
        setActiveComponentView && setActiveComponentView(activeComponentView);
        const newComponentViewPreference = {
            ...componentViewPreference,
            usageSearchResultsView: activeComponentView.viewName};
      updateUserPreferences(allResultsPerPage, defaultActiveAccordions, undefined, undefined, undefined, indexOfFirstResult, indexOfLastResult, resultsPerPage, undefined, newComponentViewPreference);
    }

    const checkIfLoaded = () => {
        const {
            findUsagePageData,
            searchViewData,
            usageType,
            roles,
            editableFields,
            setEditableFields
        } = props;

        if (findUsagePageData) {
            if (findUsagePageData.fields && findUsagePageData.fields.length > 0 && !loaded) {
                if (roles.length > 0) setLoaded(true);
                const header = findUsagePageData.fields.find(f => f.name === "PageTitle");
                if (header) {
                    document.title = header.data;
                }
            }
        }
        if (!loaded && searchViewData && searchViewData.fields && searchViewData.fields.length > 0 && (!editableFields || Object.keys(editableFields).length === 0)){
            setEditableFields(USAGESEARCH_VIEW, SEARCH_VIEW_USAGES_USAGE_TO_PRODUCT);
            setEditableFields(USAGESEARCH_VIEW, SEARCH_VIEW_USAGES_USAGE_TO_WORK);
            setEditableFields(USAGERESULTTABLE_VIEW, SEARCH_VIEW_USAGES);
        }
    }

    const onSaveEditableFields = (componentFieldName: string, key: string) => {
        const { updateComponentFieldsItems, editableFields, tabs, activeTab, usageType } = props;
        const componentInstanceForFields = componentFieldName === USAGESEARCH_VIEW ? SEARCH_VIEW_USAGES + usageType.replace(/\s+/g, '') : SEARCH_VIEW_USAGES;
        updateComponentFieldsItems(editableFields[key], componentFieldName, componentInstanceForFields, componentFieldName, tabs, activeTab);
    }

    const showFieldsModal = (componentFieldName?: string) => {
        const { settingsModalViewData } = props;
        const {
            showUpdateFieldsModal,
            editableFieldsDataView,
            dataGridTableData,
            usageType
        } = props;
        const componentInstanceForFields = componentFieldName === USAGESEARCH_VIEW ? SEARCH_VIEW_USAGES + usageType.replace(/\s+/g, '') : SEARCH_VIEW_USAGES;
        var key;

        if(componentInstanceForFields === SEARCH_VIEW_USAGES_USAGE_TO_PRODUCT){
            key = "usageToProduct"
        }
        else if(componentInstanceForFields === SEARCH_VIEW_USAGES_USAGE_TO_WORK){
            key = "usageToWork"
        }
        else if(componentInstanceForFields === SEARCH_VIEW_USAGES){
            key = "usageResultsTable"
        }
        else{
            key = "default"
        }

        const fieldsViewData: IRepertoireComponentDataItem = { fields: editableFieldsDataView.fields.filter(x => x.componentInstance === USAGE_SEARCH_EDITABLE_FIELDS) };
        const title: string = fieldsViewData.fields.find(item => item.name === TITLE_EDITABLE_FIELDS_VIEW).data;

        if(componentInstanceForFields === SEARCH_VIEW_USAGES){
            settingsModalViewData?.fields?.forEach( (field) => {
           fieldsViewData.fields.push(field);
            })
       }

        const fieldSetting: IShowFieldSettingViewModalProps = {
            componentInstance: EDITABLE_FIELDS,
            componentViewData: fieldsViewData,
            dataGridViewData: dataGridTableData,
            onClickSave: () => onSaveEditableFields(componentFieldName, key),
            key: key
        }
        showUpdateFieldsModal(title, fieldSetting, key);
    }

    const onClickNumber = (id: number) => {
        const { usageType } = props;
        if (usageType === USAGETOWORK) {
            getWorkDetails(REPERTOIRE, id);
        }
        else if (usageType === USAGETOPRODUCT) {
            getProductDetails(REPERTOIRE, id);
        }
    }

    const getWorkDetails = (dataSource: string, workID: number) => {

        const { lookupValues, workMaintenanceGeneralDataViewData, tabs, activeTab } = props;
        const dataActionList = getDataAction(dataSource, WORK_MAINTENANCE_TOOLBAR);
        const formatFields = UsageSearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, WORK_MAINTENANCE_GROUP)
            .then(formats => {
                props.getWorkDetails(dataSource, workID, lookupValues, tabs[activeTab].otherIndicatorWorkFlagTypes, tabs[activeTab].readonlyIndicatorWorkFlagTypes, dataActionList, workMaintenanceGeneralDataViewData, formats);
            });
    }

    const getProductDetails = (dataSource: string, productID: number) => {
        const { productMaintenanceGeneralDataViewData } = props;
        const formatFields = UsageSearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, PRODUCT_MAINTENANCE_GROUP)
            .then(formats => {
                props.getProductDetails(dataSource, productID, productMaintenanceGeneralDataViewData, formats);
            });
    }

    const openWorkSearchResult = ( work: IMatchWorksSearchResult, event?: React.MouseEvent ): void => {
        event?.preventDefault();
        event?.stopPropagation();

        if (!work?.workID) {
            return;
        }

        getWorkDetails(work.dataSource || REPERTOIRE, work.workID);
    };

    const openProductSearchResult = ( product: IProductSearchResult, event?: React.MouseEvent ): void => {
        event?.preventDefault();
        event?.stopPropagation();

        if (!product?.productCoreID) {
            return;
        }

        getProductDetails(product.dataSource || REPERTOIRE, product.productCoreID);
    };

    const updateUserPagination = (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => {
        const { defaultActiveAccordions, allResultsPerPage, updateUserPreferences, updatePagination } = props;
        updatePagination(indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage, repertoireSection);
        updateUserPreferences(allResultsPerPage, defaultActiveAccordions, undefined, undefined, undefined, indexOfFirstResult, indexOfLastResult, resultsPerPage, repertoireSection);
    }

    let scope =
    {
        scopes: [msalConfig.auth.scope]
    }

    const getRoles = () => {
        const { saveRoles } = props;

        instance.acquireTokenSilent({
            ...scope,
            account: accounts[0]
        }).then((response) => {
            const decodedJwtToken = ComponentsHelper.parseJwt(response.accessToken);
            const roles = decodedJwtToken.roles;
            saveRoles(roles);
        }).catch((error) => {
            saveRoles([ALL_ROLES])
        });
    }

    const addNewUsageGroup = () => {
        const { lookupValues, createNewUsageGroup } = props;
        createNewUsageGroup(lookupValues, true, undefined, currentUser);
    }

    const expanderFields = props.dataGridTableData.fields.filter(
        (field: IRepertoireField) => field.componentInstance === DATA_GRID_TABLE_FIELDS_EXPANDER);

    if (loaded) {
        const {
            searchViewData,
            bulkTargetSearchViewData,
            searchResultsTableData,
            searchUsages,
            usageGroupsSearchResult,
            matchWorkSearchResult,
            searchSuccessful,
            indexOfFirstResult,
            indexOfLastResult,
            resultsPerPage,
            currentPage,
            resetPagination,
            setIsHundredResultsPerPage,
            updatePagination,
            getUsageDetails,
            getDistributionDetails,
            getUsagePool,
            lookupValues,
            distributions,
            pools,
            sourceMajors,
            sourceMinors,
            setUsageType,
            searchMatchWorks,
            searchMatchProducts,
            usageType,
            searchDataChanged,
            matchProductsSearchResult,
            lookupSources,
            sortSearchResults,
            distributionTypes,
            continuationToken,
            updateUsageGroupMatches,
            saveUsageGroup,
            saveResultData,
            showModal,
            matchingEntityForUsageSearchCriteria,
            usageMatchingDefaultsProducts,
            usageMatchingDefaultsWorks,
            tabs,
            activeTab,
            isHundredResultsPerPage,
            matchingSources,
            poolCodeToSearch,
            searchUsagePoolsByCodeDistributionPools,
            updatePoolCodeToSearch,
            customer,
            usagePoolsSearchResults,
            searchDistributionByCode,
            distributionCodeToSearch,
            updateDistributionCodeToSearch,
            usageDistributionsSearchResults,
            usageSearchResultConfiguration,
            settingsModalViewData,
            usageSearchResultsActiveComponentView,
            componentViewPreference,
            componentViews,
            searchArtistValue,
            searchCustomerVenueCodeValue,
            searchLicenseCustomerVenueCodeValue,
            searchCustomerVenueValue,
            searchLicenseCustomerVenueValue,
            usageNumberInSearchExclude
        } = props;

        let isSearchTypeHidden: boolean = false;
        let searchTypeField = null;

        let filteredSearchViewData = { fields: [] };
        if (searchViewData) {
            const filtered = searchViewData.fields.filter(f => f.componentInstance === SEARCH_VIEW_USAGES);
            searchTypeField = filtered && filtered.find(x => x.name === 'searchType');
            isSearchTypeHidden = searchTypeField && searchTypeField.hidden
            filteredSearchViewData = { fields: searchViewData.fields.filter(f => !['usageType', 'searchType'].includes(f.name)) };
        }

        let filteredLookUpSources: ITreeData[] = [];
        let useType;
        if (usageType == USAGETOWORK) {
            useType = USAGE_TO_WORK;
        }
        else if (usageType == USAGETOPRODUCT) {
            useType = USAGE_TO_PRODUCT;
        }
        if (lookupSources) {
            filteredLookUpSources = lookupSources.filter(f => f.matchType == useType);
        }

        const getViewRoleDisabled = (): boolean => {
            const { roles } = props;
            if (roles && (roles.includes(VIEW_USAGES_ROLE) || roles.includes(ALL_ROLES))) {
                return false;
            }
            return true;
        }

        const getConfigureRoleDisabled = (): boolean => {
            const { roles } = props;
            if (roles && (roles.includes(CONFIGURE_USAGES_ROLE) || roles.includes(ALL_ROLES))) {
                return false;
            }
            return true;
        }

        const getCreateNewUsageRoleDisabled = (): boolean => {
            const { roles } = props;
            if (roles && (roles.includes(CREATE_NEW_USAGE_ROLE) || roles.includes(ALL_ROLES))) {
                return false;
            }
            return true;
        }

        return (
            <div className="findUsagePage">
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <span className="title">Find Usage Information</span>
                            <div >
                                <button className="editBtn" title="Configure data fields" onClick={() => showFieldsModal(USAGESEARCH_VIEW)} disabled={getConfigureRoleDisabled()}>
                                    <Settings20Regular />
                                </button>
                                <div className="newUsageGroupButton newWorkButton" title="Add New Usage Group" style={{ paddingRight: "24px" }} hidden={getCreateNewUsageRoleDisabled()}>
                                <div className="IconTextButton" onClick={addNewUsageGroup} >
                                    <AddCircle20Regular className="icon" aria-hidden="true" />
                                    New Usage Group
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="row">
                        <SelectorView
                            selection={usageType}
                            setSelection={setUsageType}
                            option1={USAGETOWORK}
                            option1Label={USAGETOWORK}
                            option2={USAGETOPRODUCT}
                            option2Label={USAGETOPRODUCT}
                        />
                        <SelectorView
                            selection={searchType}
                            setSelection={setSearchType}
                            option1={SIMPLE}
                            option1Label={(searchViewData.fields.find(f => f.name === SIMPLE)?.data || SIMPLE)
                                .toLowerCase().replace(/^./, c => c.toUpperCase())}
                            option2={ADVANCED}
                            option2Label={(searchViewData.fields.find(f => f.name === ADVANCED)?.data || ADVANCED)
                                .toLowerCase().replace(/^./, c => c.toUpperCase())}
                            option3={option3}
                            option3Label={option3Label}
                            selectorTitle={searchTypeField && searchTypeField.data}
                        />
                        {props.enableUsageSearchSourceSelector && (
                            <SelectorView
                                selection={searchSource}
                                setSelection={setSearchSource}
                                option1={USAGE_SEARCH_SOURCE_COSMOS}
                                option1Label={USAGE_SEARCH_SOURCE_PRIMARY_LABEL}
                                option2={USAGE_SEARCH_SOURCE_LAKEHOUSE}
                                option2Label={USAGE_SEARCH_SOURCE_LAKEHOUSE}
                            />
                        )}
                    </div>
                </div>
                {searchType === option3 ? (
                    <AiSearchView
                        searchDisabled={getViewRoleDisabled()}
                        dataSource={usageType}
                        pageName={SEARCH_VIEW_USAGES}
                        getUsageDetails={props.getUsageDetails}
                        searchMatchWorks={searchMatchWorks}
                        matchWorkSearchResult={matchWorkSearchResult}
                        searchMatchProducts={searchMatchProducts}
                        matchProductsSearchResult={matchProductsSearchResult}
                        searchResultsTableData={searchResultsTableData}
                        openWorkSearchResult={openWorkSearchResult}
                        openProductSearchResult={openProductSearchResult}
                    />
                ) : 
                (
                    <UsageSearchView
                        userIsConfigureComponentViewAdmin={userIsConfigureComponentViewAdmin}
                        componentViews={componentViews}
                        usageSearchResultsActiveComponentView={usageSearchResultsActiveComponentView}
                        setActiveComponentView={onSetActiveComponentView}
                        searchViewData={filteredSearchViewData}
                        bulkTargetSearchViewData={bulkTargetSearchViewData}
                        searchMatchWorks={searchMatchWorks}
                        searchMatchProducts={searchMatchProducts}
                        matchProductsSearchResult={matchProductsSearchResult}
                        matchWorkSearchResult={matchWorkSearchResult}
                        getWorkDetails={openWorkSearchResult}
                        getProductDetails={openProductSearchResult}
                        submitBulkMatch={props.submitBulkMatch}
                        canUpdateUsages={canUpdateUsages}
                        searchResultsTableData={searchResultsTableData}
                        settingsModalViewData={settingsModalViewData}
                        componentInstance={SEARCH_VIEW_USAGES}
                        modalProps={undefined}
                        searchUsages={searchUsages}
                        usageGroup={tabs[activeTab]?.usageMaintenanceState?.usageGroup}
                        usageGroupsSearchResult={usageGroupsSearchResult}
                        searchSuccessful={searchSuccessful}
                        indexOfFirstResult={indexOfFirstResult}
                        indexOfLastResult={indexOfLastResult}
                        resultsPerPage={resultsPerPage}
                        currentPage={currentPage}
                        resetPagination={resetPagination}
                        setIsHundredResultsPerPage={setIsHundredResultsPerPage}
                        updatePagination={updateUserPagination}
                        sourceMinors={sourceMinors}
                        sourceMajors={sourceMajors}
                        matchingSources={matchingSources}
                        distributions={distributions}
                        pools={pools}
                        lookupValues={lookupValues}
                        hideModal={undefined}
                        getUsageDetails={getUsageDetails}
                        getDistributionDetails={getDistributionDetails}
                        getUsagePool={getUsagePool}
                        expandedMatchWorkResults={undefined}
                        usageExpandAll={undefined}
                        expandMatchWorkResult={undefined}
                        usageExpandAllResults={undefined}
                        searchDataChanged={searchDataChanged}
                        usageType={usageType}
                        searchSource={searchSource}
                        onClickNumber={onClickNumber}
                        lookupSources={filteredLookUpSources}
                        sortSearchResults={sortSearchResults}
                        distributionTypes={distributionTypes}
                        continuationToken={continuationToken}
                        showFieldsModal={showFieldsModal}
                        searchDisabled={getViewRoleDisabled()}
                        updateUsageGroupMatches={updateUsageGroupMatches}
                        saveUsageGroup={saveUsageGroup}
                        saveResultData={saveResultData}
                        searchType={searchType}
                        expanderFieldsData={expanderFields}
                        showModal={showModal}
                        matchingEntityForUsageSearchCriteria={matchingEntityForUsageSearchCriteria}
                        usageMatchingDefaultsWorks={usageMatchingDefaultsWorks}
                        usageMatchingDefaultsProducts={usageMatchingDefaultsProducts}
                        isHundredResultsPerPage={isHundredResultsPerPage}
                        searchUsagePoolsByCodeDistributionPools={searchUsagePoolsByCodeDistributionPools}
                        poolCodeToSearch={poolCodeToSearch}
                        updatePoolCodeToSearch={updatePoolCodeToSearch}
                        customer={customer}
                        usagePoolsSearchResults={usagePoolsSearchResults}
                        searchDistributionByCode={searchDistributionByCode }
                        distributionCodeToSearch={distributionCodeToSearch }
                        updateDistributionCodeToSearch={updateDistributionCodeToSearch }
                        usageDistributionsSearchResults={usageDistributionsSearchResults}
                        usageSearchResultConfiguration={usageSearchResultConfiguration}
                        componentViewPreference={componentViewPreference}
                        searchArtistValue={searchArtistValue}
                        searchCustomerVenueCodeValue={searchCustomerVenueCodeValue}
                        searchLicenseCustomerVenueCodeValue={searchLicenseCustomerVenueCodeValue}
                        searchCustomerVenueValue={searchCustomerVenueValue}
                        searchLicenseCustomerVenueValue={searchLicenseCustomerVenueValue}
                        usageNumberInSearchExclude={usageNumberInSearchExclude}
                    />
                )}
            </div>
        );
    }
    return <div />;
}

export default FindUsagePage;
